<template>
  <b-row>
    <b-col lg="6" v-for="item in contents" :key="item.title">
      <b-card :title="item.title">
        <app-timeline>
          <app-timeline-item
            v-for="content in item.elements"
            :key="content.id"
            :icon="getType(content.type).icon"
            :variant="getColor()"
          >
            <div
              class="
                d-flex
                flex-sm-row flex-column flex-wrap
                justify-content-between
                mb-1 mb-sm-0
              "
            >
              <b-link @click="goToContent(content)"
                ><h6>{{ content.name }}</h6></b-link
              >
              <small class="text-muted">{{
                GetDateTimeZone(content.rooms[0].pivot.start_in)
              }}</small>
            </div>
            <small>{{ getType(content.type).title }}</small>
          </app-timeline-item>
        </app-timeline>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import EduContentController from "@/Controllers/EduContentController";
import Auth from "@/Apis/Auth";
import SemesterController from '@/Controllers/SemesterController';
export default {
  components: {
    AppTimeline,
    AppTimelineItem,
  },
  data() {
    return {
      contents: [],
      text: "",
      textCh: "",
      load: false,
     GetDateTimeZone :Auth.GetDateTimeZone,
    };
  },
  async created() {
    this.$mobileTitle.label=this.$i18n.t('edu_programs.educational_path'); 

    let id = localStorage.getItem("eduProgram");
    let ed = Auth.EDU_PROGRAMS.find((a) => a.id == id);
    let room = Auth.ROOM.find((a) => a.edu_program_id == id);
    let res = await new EduContentController().getAllContents(id, {
      room_id: room.id,
    });
    const data = res.sort(function (a, b) {
      var c = new Date(a.rooms[0].pivot.start_in);
      var d = new Date(b.rooms[0].pivot.start_in);
      return c - d;
    });
    const contents = [];
   
   const numOfSemesters = await new SemesterController().GetAll({
      filter: "edu_program_id|" + ed.id,
    });
    numOfSemesters.forEach(semester => {
       const element = data.filter(
        (a) => a.rooms[0].pivot.semester_num == semester.id
      );
      contents.push({ elements: element, title: semester.name });
    });
   
     
    
    this.contents = contents;
  },
  methods: {
    getNumber(number) {
      var ones = [
        "صفر",
        "الفصل الدراسي الاول ",
        "الفصل الدراسي الثانى",
        "الفصل الدراسي الثالث ",
      ];
      return ones[number];
    },
     getType(type) {
      return new EduContentController().GetType(type);
    },
    goToContent(content) {
      let item = {
        id: content.id,
        name: content.name,
        type: content.type,
        description: content.description,
        start_in: content.rooms[0].pivot.start_in,
        end_in: content.rooms[0].pivot.end_in,
        file: content.file,
        data: content,
        exam_id: content.exam_id,
        h5p: content.h5p_content_id,
        online_class_ids: content.online_class_ids,
      };
      localStorage.setItem("content", JSON.stringify(item));
      this.$router.push({ name: "Courses" });
    },
    getColor() {
      let color = [
        "primary",
        "secondary",
        "success",
        "warning",
        "danger",
        "info",
      ];
      return color[Math.floor(Math.random() * 5)];
    },
  },
};
</script>

<style>
</style>